<div class="cell auto cell-block-y revertPeriod">
    <div class="revertPeriod-illu"></div>

    <h2 class="revertPeriod-title"[i18nKey]="'revert.period.title'"></h2>

    <kiwi-spacer [size]="24"></kiwi-spacer>

    <div class="revertPeriod-history-block">
        <div class="revertPeriod-history-block-item" *ngFor="let simulatedPeriod of simulatedPeriods">
            <div class="revertPeriod-history-block-item-infos">
                <div class="text-center">
                    <kiwi-period class="revertPeriod-history-period" [period]="simulatedPeriod.period"></kiwi-period>
                    <div>
                        <span [i18nKey]="'revert.period.simulated.at'"></span> {{simulatedPeriod.simulationDate | date:'short':'':'fr-FR'}}
                        <span [i18nKey]="'common.by'"></span>
                    </div>
                    <div class="revertPeriod-by">
                        {{simulatedPeriod.simulatedBy.firstName}} {{simulatedPeriod.simulatedBy.lastName}}
                    </div>
                </div>
                <button class="button _small" (click)="revertPeriod(simulatedPeriod.period)">
                    <i class="fas fa-history"></i><span [i18nKey]="'revert.period.action'"></span>
                </button>
            </div>
        </div>
    </div>
</div>
